var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"container mt-5"},[_c('hr'),_vm._v(" "),_c('pre',{staticClass:"text-right text-muted"},[_vm._v("v"+_vm._s(_vm.version))])])],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78e5b53a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/no-nav.vue
// module id = null
// module chunks = 